import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import React, { useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { OnboardingData, OnboardingRoutes } from '../..';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { ButtonVariant } from '../../../../components/Button/Button';
import { OnboardingStep, OnboardingTitle } from '../../components';
import OnboardingPaneHeader from '../../components/OnboardingPaneHeader';
import OnboardingReferenceDataForm from './components/OnboardingReferenceDataForm';

interface OnboardingEditReferenceDataPaneProps {
  data: OnboardingData;
  onSave: (productMasterData: ProductMasterData) => void;
}

export default function OnboardingReferenceDataEditPane({ data, onSave }: OnboardingEditReferenceDataPaneProps) {
  const navigate = useNavigate();

  const id = useParams()['id'] || '';

  const found = [...data.summary.productMasterData.values()].find(pmd => pmd.id === id);
  if (!found) return <Navigate to={OnboardingRoutes.referenceDataOverview} replace />;

  const [productMasterData, setProductMasterData] = useState(new ProductMasterData(found));

  return (
    <div className='grid gap-4'>
      <OnboardingPaneHeader back={() => navigate(-1)} />
      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Edit your Product Reference Data'} />
      </div>

      <OnboardingReferenceDataForm
        existing={data.summary.productMasterData}
        productMasterData={productMasterData}
        setProductMasterData={setProductMasterData}
      />

      <div className='flex gap-2'>
        <Button
          text={t(TranslationKey.save).singular.label}
          onClick={() => {
            onSave(productMasterData);
            navigate(OnboardingRoutes.referenceDataOverview);
          }}
        />
        <Button
          variant={ButtonVariant.linkPrimary}
          text={t(TranslationKey.cancel).singular.label}
          onClick={() => navigate(OnboardingRoutes.referenceDataOverview)}
        />
      </div>
    </div>
  );
}
